// Mock data for Subham Anand's Digital Marketing Portfolio

export const personalInfo = {
  name: "Subham Anand",
  title: "Senior GEO and Digital Marketing Expert",
  location: "Bengaluru, India",
  phone: "9972137962",
  email: "shubhamanand93@gmail.com",
  headshot: "https://customer-assets.emergentagent.com/job_3e27309a-d123-4d9a-9f28-4ccf464db2bb/artifacts/tjtrdyep_30893.png",
  tagline: "Driving Growth Through AI-Powered Digital Strategies",
  summary: "Senior GEO and Digital Marketing Expert with over 7 years of experience in AI-driven SEO strategies, technical SEO, Paid Campaigns, and content optimization. Proficient in Google Analytics, SEMrush, Meta Ads, Google Ads, Ahrefs, Looker Studio, and Screaming Frog for performance analysis. Skilled in CRO techniques to enhance user experience and boost conversion rates."
};

export const achievements = [
  {
    id: 1,
    metric: "60%",
    description: "Increase in Organic Traffic",
    icon: "TrendingUp"
  },
  {
    id: 2,
    metric: "40%",
    description: "Boost in Conversion Rates",
    icon: "Target"
  },
  {
    id: 3,
    metric: "200+",
    description: "Qualified Leads Generated",
    icon: "Users"
  },
  {
    id: 4,
    metric: "35%",
    description: "ROI Increase Achieved",
    icon: "DollarSign"
  },
  {
    id: 5,
    metric: "20%",
    description: "Reduction in CPA",
    icon: "ArrowDown"
  },
  {
    id: 6,
    metric: "150%",
    description: "Social Media Growth",
    icon: "Share2"
  }
];

export const experience = [
  {
    id: 1,
    position: "Marketing Executive",
    company: "Wire2Air Business Messaging",
    location: "Bengaluru",
    startDate: "June 2023",
    endDate: "Present",
    description: "Leading AI-driven SEO strategies and cross-functional marketing initiatives to drive organic growth and conversions.",
    responsibilities: [
      "Developed and executed AI-driven SEO strategies, optimizing website content and improving keyword rankings",
      "Led cross-functional teams to enhance user engagement and drive organic traffic growth",
      "Pioneered Generative Engine Optimization (GEO) strategies to list core product keywords within AI-overviews",
      "Implemented advanced targeting and retargeting strategies with A/B testing on ad creatives"
    ],
    achievements: [
      "60% increase in organic traffic",
      "25% increase in conversion rates",
      "Reduced CPA by 20%",
      "35% increase in market share"
    ]
  },
  {
    id: 2,
    position: "Marketing Associate",
    company: "Opteamix LLC",
    location: "Bangalore",
    startDate: "February 2021",
    endDate: "June 2023",
    description: "Implemented AI-driven marketing tools and managed cross-functional campaigns for B2B lead generation.",
    responsibilities: [
      "Implemented AI-driven marketing tools to optimize website architecture and technical SEO",
      "Utilized AI-based content strategies to reduce bounce rates and increase conversion rates",
      "Streamlined B2B lead acquisition by optimizing landing pages and managing CRM (HubSpot) workflows",
      "Conducted A/B testing for email campaigns"
    ],
    achievements: [
      "40% increase in organic traffic",
      "Generated 200+ qualified leads",
      "25% lift in email open rates",
      "20% increase in click-through rates"
    ]
  },
  {
    id: 3,
    position: "Digital Marketing Executive",
    company: "Maxium Media Pvt Ltd",
    location: "Bangalore",
    startDate: "February 2018",
    endDate: "February 2021",
    description: "Optimized SEM campaigns and led social media strategies for diverse client portfolios.",
    responsibilities: [
      "Optimized SEM campaigns for a portfolio of clients with comprehensive reporting",
      "Authored and executed PPC training programs with advanced analytic techniques",
      "Piloted a successful PPC automation project",
      "Created and implemented social media strategies across platforms"
    ],
    achievements: [
      "17% increase in average click-through rate",
      "35% ROI increase across campaigns",
      "150% follower increase over two years",
      "Generated 200+ leads for restaurant clients"
    ]
  }
];

export const skills = [
  { id: 1, name: "Google Analytics 4", category: "Analytics" },
  { id: 2, name: "SEMrush", category: "SEO" },
  { id: 3, name: "Ahrefs", category: "SEO" },
  { id: 4, name: "Google Ads", category: "Paid Media" },
  { id: 5, name: "Meta Ads", category: "Paid Media" },
  { id: 6, name: "LinkedIn Ads", category: "Paid Media" },
  { id: 7, name: "TikTok Ads", category: "Paid Media" },
  { id: 8, name: "HubSpot CRM", category: "Marketing Automation" },
  { id: 9, name: "Looker Studio", category: "Analytics" },
  { id: 10, name: "Screaming Frog", category: "SEO" },
  { id: 11, name: "Google Search Console", category: "SEO" },
  { id: 12, name: "Technical SEO", category: "SEO" },
  { id: 13, name: "Email Marketing", category: "Marketing Automation" },
  { id: 14, name: "AI-Driven SEO", category: "SEO" },
  { id: 15, name: "CRO", category: "Optimization" }
];

export const education = [
  {
    id: 1,
    institution: "Growth School",
    degree: "Performance Marketing",
    year: "2025"
  },
  {
    id: 2,
    institution: "Growth School",
    degree: "Growth Marketing",
    year: "2024"
  },
  {
    id: 3,
    institution: "IIM Indore",
    degree: "Certificate Programme in Digital Marketing & Strategy",
    year: "2023"
  },
  {
    id: 4,
    institution: "Growth School",
    degree: "SEO Course",
    year: "2023"
  },
  {
    id: 5,
    institution: "School Of Management, Manipal",
    degree: "MBA",
    year: "2017"
  },
  {
    id: 6,
    institution: "Siddaganga Institute Of Technology",
    degree: "B.E. in Mechanical Engineering",
    year: "2013"
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "Generative Engine Optimization (GEO) for Wire2Air",
    client: "Wire2Air Business Messaging",
    description: "Pioneered GEO strategies to position Wire2Air's text-to-email and SMS services in AI-powered search results and AI Overviews, driving organic visibility in the emerging AI search landscape.",
    challenge: "With the rise of AI-powered search engines, traditional SEO wasn't enough. Wire2Air needed visibility in AI Overviews and conversational search results to capture emerging search traffic.",
    solution: "Developed and executed comprehensive GEO strategies focusing on structured content, semantic optimization, and AI-friendly formatting to ensure core product features appeared in AI Overviews for relevant queries like 'text to email service' and 'SMS forwarding'.",
    results: [
      "250+ AI-driven sessions tracked in December 2025",
      "Traffic from ChatGPT, Perplexity, Gemini, and other AI platforms",
      "60% increase in organic traffic with AI as new channel",
      "84.85% engagement rate from ChatGPT referrals",
      "15.33 events per session from AI traffic sources"
    ],
    image: "https://customer-assets.emergentagent.com/job_growth-marketing-hub-1/artifacts/e9eozz8r_AI%20Overviews%202.jpg",
    analyticsImages: [
      {
        url: "https://customer-assets.emergentagent.com/job_growth-marketing-hub-1/artifacts/qri5t6h4_iScreen%20Shoter%20-%20Google%20Chrome%20-%20260203132714.jpg",
        caption: "Sessions by Channel: AI traffic emerged as a distinct channel with 250 sessions, demonstrating successful GEO implementation"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_growth-marketing-hub-1/artifacts/3yzd7ogb_iScreen%20Shoter%20-%20Google%20Chrome%20-%20260204201350.jpg",
        caption: "AI Referrers: Major AI platforms (Perplexity, ChatGPT, Gemini) driving targeted traffic to Wire2Air content"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_growth-marketing-hub-1/artifacts/l4umnd58_iScreen%20Shoter%20-%20Google%20Chrome%20-%20260203124428.jpg",
        caption: "Conversion Performance: AI-driven traffic showing exceptional engagement with 9.95 events per session average"
      }
    ],
    tags: ["GEO", "AI Marketing", "SEO", "Wire2Air"]
  },
  {
    id: 2,
    title: "10DLC Compliance Content Marketing Strategy",
    client: "Wire2Air Business Messaging",
    description: "Created comprehensive content strategy around 10DLC registration deadline, establishing Wire2Air as the authority on SMS compliance and driving massive organic traffic during critical industry deadline.",
    challenge: "The February 1, 2025 10DLC deadline was approaching. Businesses needed guidance on compliance, and Wire2Air needed to position itself as the go-to solution provider in a time-sensitive market.",
    solution: "Developed targeted content addressing 10DLC registration, compliance requirements, and solution implementation. Optimized for both traditional search and AI Overviews to capture decision-makers researching compliance solutions.",
    results: [
      "Achieved AI Overview placement for '10DLC deadline' queries",
      "40% increase in organic traffic during campaign period",
      "200+ qualified B2B leads generated",
      "Established thought leadership in SMS compliance"
    ],
    image: "https://customer-assets.emergentagent.com/job_growth-marketing-hub-1/artifacts/ppeeqdij_AI%20Overviews%203.jpg",
    tags: ["Content Marketing", "B2B", "Compliance", "Lead Generation"]
  },
  {
    id: 3,
    title: "SMS-to-Email Service Visibility Campaign",
    client: "Wire2Air Business Messaging",
    description: "Executed multi-channel content strategy to dominate search results for SMS-to-email and text forwarding services, achieving prominent placement in both traditional SERPs and AI-powered search results.",
    challenge: "Highly competitive keyword space with established players. Needed to differentiate Wire2Air's offerings and capture users searching for SMS-to-email solutions across multiple search platforms.",
    solution: "Created comprehensive content covering multiple use cases (IFTTT integration, TXTImpact features, automated forwarding), optimized for semantic search and AI comprehension, with structured data implementation.",
    results: [
      "Featured in AI Overviews for multiple high-value queries",
      "30% increase in organic traffic for target keywords",
      "20% reduction in CPA",
      "Improved brand recognition in B2B messaging space"
    ],
    image: "https://customer-assets.emergentagent.com/job_growth-marketing-hub-1/artifacts/oam9tfn4_AI%20Overviews%204%20%281%29.jpg",
    tags: ["SEO", "GEO", "Product Marketing", "SaaS"]
  },
  {
    id: 4,
    title: "High-ROI Lean Conversion Strategy (INR)",
    client: "Indian Market E-commerce Client",
    description: "Maximized Return on Ad Spend through hyper-efficient targeting and cost-per-result optimization in the Indian market, achieving exceptional conversion rates with minimal spend.",
    challenge: "The client required maximum ROI from limited advertising budgets in the highly competitive Indian e-commerce market, demanding precise targeting and cost optimization.",
    solution: "Implemented hyper-efficient targeting strategies with specialized testing and scaling phases, focusing on high-intent audience segments to minimize cost per acquisition while maintaining conversion quality.",
    results: [
      "888 website purchases achieved",
      "Average cost per purchase of ₹60.05",
      "Top ad sets at ₹36.10 per purchase",
      "₹53,326 total spend for 888 conversions"
    ],
    image: "/images/meta1.jpg",
    tags: ["Meta Ads", "High-ROI", "INR Market", "Cost Optimization"]
  },
  {
    id: 5,
    title: "Enterprise-Level Global Scaling (EUR)",
    client: "European E-commerce Enterprise",
    description: "Demonstrated capability to handle enterprise-level Meta Ads budgets exceeding €4.2M, achieving massive scale and market penetration within the European market with stable conversion rates.",
    challenge: "Managing million-euro advertising budgets while maintaining stable cost per purchase and achieving market penetration across the European region at unprecedented scale.",
    solution: "Developed enterprise-grade campaign management strategies with sophisticated budget allocation, audience segmentation, and real-time optimization to maintain KPI stability at extreme spending levels.",
    results: [
      "€4,284,634 total ad spend managed",
      "62,381 website purchases generated",
      "50.9M unique users reached",
      "100M+ total impressions"
    ],
    image: "/images/meta4.jpg",
    tags: ["Meta Ads", "Enterprise", "EUR Market", "Global Scaling"]
  },
  {
    id: 6,
    title: "High-Velocity E-commerce Scaling (USD)",
    client: "International E-commerce Client",
    description: "Managed a high-frequency, high-volume Meta Ads campaign for an international e-commerce market, achieving exceptional results through strategic ad set optimization and massive impression delivery.",
    challenge: "The client needed to rapidly scale their e-commerce operations in international markets while maintaining cost-efficient customer acquisition in a competitive USD market.",
    solution: "Implemented a high-volume approach with multiple optimized ad sets, focusing on maintaining low CPMs while maximizing purchase conversions. Utilized strategic frequency management to prevent audience fatigue.",
    results: [
      "5,836+ website purchases generated",
      "Cost per purchase as low as $4.62 on top performers",
      "26.4M+ total impressions delivered",
      "CPM range of $0.68 - $2.18 maintained"
    ],
    image: "/images/meta3.jpg",
    tags: ["Meta Ads", "E-Commerce", "USD Market", "Performance Marketing"]
  },
  {
    id: 7,
    title: "Precision Bidding & Campaign Stability (INR)",
    client: "Indian E-commerce Brand",
    description: "Showcased technical proficiency in utilizing various Meta bid strategies to stabilize and scale high-performing campaigns, achieving consistent conversion milestones with diversified budget allocation.",
    challenge: "Scaling campaigns while maintaining 'High Performing' status required precise bid strategy management and diversified ad set budgets to ensure consistent delivery and conversions.",
    solution: "Utilized a strategic mix of 'Highest Volume' and 'Cost Per Result Goal' bid strategies across multiple ad sets with varied daily budgets (₹2,000 - ₹4,000) to ensure steady conversion flow and optimal performance.",
    results: [
      "12,650 website purchases achieved",
      "Meta 'High Performing' label earned",
      "Multiple bid strategies optimized",
      "Diversified ₹2K-₹4K daily budgets",
      "Consistent conversion flow maintained"
    ],
    image: "/images/meta2.jpg",
    tags: ["Meta Ads", "Bid Strategy", "INR Market", "Campaign Stability"]
  },
  {
    id: 8,
    title: "WordPress Technical SEO Overhaul",
    client: "Opteamix LLC",
    description: "Led comprehensive technical SEO audit and optimization for Opteamix's WordPress website, focusing on Core Web Vitals improvement, page speed optimization, and user experience enhancement across mobile and desktop versions.",
    challenge: "The existing Opteamix website had poor Core Web Vitals scores affecting both user experience and search rankings. Key metrics like LCP, FCP, TBT, and CLS needed significant improvement to meet Google's performance standards.",
    solution: "Executed a complete technical SEO overhaul including image optimization, code minification, lazy loading implementation, server-side optimizations, and CDN utilization. Restructured the website architecture to improve Time to First Byte and overall page speed.",
    results: [
      "Significant improvement in Core Web Vitals scores",
      "Optimized Time to First Byte (TTFB) and First Contentful Paint (FCP)",
      "Reduced Largest Contentful Paint (LCP) below 2.5s threshold",
      "Minimized Cumulative Layout Shift (CLS) for better UX",
      "40% improvement in organic traffic post-optimization"
    ],
    image: "/images/seo1.png",
    analyticsImages: [
      {
        url: "/images/seo2.png",
        caption: "Old vs New Site Comparison: Desktop version performance metrics before and after optimization"
      },
      {
        url: "/images/seo3.png",
        caption: "Mobile Performance: Core Web Vitals comparison showing improvements in TTFB, FCP, and LCP"
      },
      {
        url: "/images/seo4.png",
        caption: "Speed Index & Total Blocking Time: Detailed metrics showing page speed improvements"
      },
      {
        url: "/images/seo5.png",
        caption: "Cumulative Layout Shift: Visual stability improvements reducing layout shifts"
      }
    ],
    tags: ["Technical SEO", "Core Web Vitals", "WordPress", "Page Speed"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    position: "CEO, Wire2Air",
    company: "Wire2Air Business Messaging",
    text: "Subham's AI-driven SEO strategies transformed our organic presence. His innovative approach to GEO positioning helped us rank in AI-powered search results, driving a 60% increase in quality traffic.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Mitchell",
    position: "Marketing Director",
    company: "Opteamix LLC",
    text: "Working with Subham was a game-changer for our B2B lead generation. His systematic approach to landing page optimization and CRM workflows delivered 200+ qualified leads consistently.",
    rating: 5
  },
  {
    id: 3,
    name: "Priya Sharma",
    position: "Founder",
    company: "Digital Growth Agency",
    text: "Subham's expertise in paid campaigns and social media strategy is exceptional. He achieved a 150% follower growth for our client while maintaining a 35% ROI increase.",
    rating: 5
  }
];